module.exports = __webpack_public_path__ + "static/media/img8.bdb599c2.png";